import { render, staticRenderFns } from "./CwpePricing.vue?vue&type=template&id=3f493e70&scoped=true&"
import script from "./CwpePricing.vue?vue&type=script&lang=js&"
export * from "./CwpePricing.vue?vue&type=script&lang=js&"
import style0 from "./CwpePricing.vue?vue&type=style&index=0&id=3f493e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f493e70",
  null
  
)

export default component.exports